<template>
  <v-col cols="12" md="6">
    <v-card color="kbWhite">
      <v-card-title>
        {{$t('general.waitTime')}}
      </v-card-title>
      <v-card-text>
        <canvas id="canvas-wait-time"></canvas>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import colorsChart from '@/libs/colorsChart.js'

export default {
  computed: {
    ...mapState({
      statistics: state => state.conversations.statistics
    }),
    info () {
      return {
        labels: [],
        datasets: [
          {
            label: this.$t('general.waitTime'),
            backgroundColor: colorsChart.red,
            data: []
          }
        ]
      }
    },
    language () {
      return this.$i18n.locale
    }
  },
  data: () => ({
    chart: null
  }),
  methods: {
    renderChart () {
      this.setData()
      let ctx = document.getElementById('canvas-wait-time').getContext('2d') // eslint-disable-line
      this.chart = new Chart(ctx, { // eslint-disable-line
        type: 'horizontalBar',
        data: this.info,
        options: {
          indexAxis: 'y',
          responsive: true,
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: this.$t('general.conversationsNumber')
              },
              display: true,
              ticks: {
                suggestedMin: 0,
                beginAtZero: true,
                suggestedMax: 100
              }
            }],
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: `${this.$t('general.time')} (Seg o Min)`
              }
            }]
          }
        }
      })
    },
    setData () {
      if (!this.statistics) return {}

      this.info.labels = []
      this.info.datasets[0].data = []

      const waitingFirst = this.statistics.WaitingTimeFirstResponse

      waitingFirst.forEach(item => {
        switch (item._id) {
          case 0:
            this.info.labels.push('<30s')
            break
          case 30000:
            this.info.labels.push('30s 60s')
            break
          case 60000:
            this.info.labels.push('1m 2m')
            break
          case 120000:
            this.info.labels.push('2m 5m')
            break
          case 300000:
            this.info.labels.push('5m 6m')
            break
          default:
            this.info.labels.push(item._id)
        }

        this.info.datasets[0].data.push(item.Count)
      })
    },
    updateChart () {
      this.setData()
      this.chart.update()
    }
  },
  watch: {
    statistics (value) {
      if (!value) return

      if (this.chart) {
        this.updateChart()
      } else {
        this.renderChart()
      }
    },
    language () {
      this.renderChart()
    }
  }
}
</script>
